import { useState, useEffect } from 'react';
import { Button } from '../ui';
import { Cookie } from 'lucide-react';

const COOKIE_CONSENT_KEY = 'cookieConsent';

/**
 * Banner per il consenso dei cookie
 * Appare in basso se l'utente non ha ancora accettato
 */
function CookieConsentBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Controlla se il consenso è già stato dato
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Piccolo delay per evitare flash durante il caricamento
      const timer = setTimeout(() => setIsVisible(true), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(
      COOKIE_CONSENT_KEY,
      JSON.stringify({
        accepted: true,
        timestamp: new Date().toISOString(),
      })
    );
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-40 p-3 sm:p-4 bg-background border-t border-border shadow-lg animate-slideUp"
      style={{
        paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))',
        paddingLeft: 'max(0.75rem, env(safe-area-inset-left))',
        paddingRight: 'max(0.75rem, env(safe-area-inset-right))',
      }}
    >
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4">
        <div className="flex items-start gap-2 sm:gap-3">
          <Cookie className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
          <div className="text-sm">
            <p className="font-medium">Utilizziamo i cookie</p>
            <p className="text-muted-foreground text-xs sm:text-sm">
              Questo sito utilizza cookie tecnici necessari per il funzionamento.
              Continuando la navigazione accetti l'utilizzo dei cookie.
            </p>
          </div>
        </div>
        <div className="flex gap-2 flex-shrink-0 w-full sm:w-auto">
          <Button onClick={handleAccept} size="sm" className="w-full sm:w-auto min-h-[44px] touch-manipulation">
            Accetta
          </Button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsentBanner;
